export const AUTO_COMPLETE = 'autoComplete';
export const CAPTCHA = 'captcha';
export const CHECK = 'check';
export const DEVICE = 'device';
export const PLAYLIST = 'playlist';
export const KEY_VALUE_LIST = 'keyValueList';
export const MONITOR_ALBUMS_SELECT = 'monitorAlbumsSelect';
export const NUMBER = 'number';
export const OAUTH = 'oauth';
export const PASSWORD = 'password';
export const PATH = 'path';
export const QUALITY_PROFILE_SELECT = 'qualityProfileSelect';
export const METADATA_PROFILE_SELECT = 'metadataProfileSelect';
export const ALBUM_RELEASE_SELECT = 'albumReleaseSelect';
export const ROOT_FOLDER_SELECT = 'rootFolderSelect';
export const SELECT = 'select';
export const SERIES_TYPE_SELECT = 'artistTypeSelect';
export const TAG = 'tag';
export const TEXT = 'text';
export const TEXT_TAG = 'textTag';

export const all = [
  AUTO_COMPLETE,
  CAPTCHA,
  CHECK,
  DEVICE,
  PLAYLIST,
  KEY_VALUE_LIST,
  MONITOR_ALBUMS_SELECT,
  NUMBER,
  OAUTH,
  PASSWORD,
  PATH,
  QUALITY_PROFILE_SELECT,
  METADATA_PROFILE_SELECT,
  ALBUM_RELEASE_SELECT,
  ROOT_FOLDER_SELECT,
  SELECT,
  SERIES_TYPE_SELECT,
  TAG,
  TEXT,
  TEXT_TAG
];
